import type { FC } from 'react';

export const LogoSymbolOnly: FC = () => (
  <svg
    width="52"
    height="44"
    viewBox="0 0 52 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_19_1165"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="52"
      height="44"
    >
      <path d="M51.3928 0H0V44H51.3928V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_19_1165)">
      <path
        d="M0 22.3764C0 27.6363 1.81443 32.4764 4.85457 36.2935C9.01426 36.1777 12.9278 37.857 15.7074 40.7234C16.272 40.5207 16.8559 40.3567 17.4639 40.2408C21.585 39.4591 25.5999 41.0274 28.1478 44C30.966 43.2472 33.567 41.9636 35.835 40.2553L29.4749 36.1198C27.3516 37.22 24.934 37.8425 22.3764 37.8425C13.835 37.8425 6.91511 30.9177 6.91511 22.3764C6.91511 13.8351 13.8399 6.91511 22.3764 6.91511C23.0761 6.91511 23.7662 6.96337 24.4418 7.05023L26.1211 0.313665C24.9002 0.106164 23.6504 0 22.3764 0C10.018 0 0 10.018 0 22.3764Z"
        fill="url(#paint0_linear_19_1165)"
      />
      <path
        d="M32.0084 1.9495L29.0986 15.3357C28.6788 17.2612 29.335 17.5748 30.5559 16.021L32.988 12.9326C34.2089 11.3835 36.4046 10.3412 37.8716 10.6211C39.3385 10.901 39.6956 9.75253 38.663 8.06839L34.6432 1.50555C34.1751 0.738272 33.6733 0.366699 33.2293 0.366699C32.6937 0.366699 32.2401 0.902343 32.0084 1.9495Z"
        fill="url(#paint1_linear_19_1165)"
      />
      <path
        d="M23.3852 10.6597L15.9007 12.4549C13.9849 12.9133 13.8015 14.1149 15.4953 15.1234L27.0575 21.9855C28.7513 22.994 29.2725 22.4535 28.2156 20.7935L26.1889 17.6134C25.1272 15.9486 24.8474 13.5165 25.5664 12.2088C26.1358 11.1761 25.6388 10.5246 24.4613 10.5246C24.1476 10.515 23.7857 10.5632 23.3852 10.6597Z"
        fill="url(#paint2_linear_19_1165)"
      />
      <path
        d="M21.1217 25.8943L20.5185 33.567C20.3641 35.531 21.4547 36.086 22.9458 34.7927L33.0651 26.0197C34.5563 24.7265 34.2088 24.0557 32.293 24.5238L28.6111 25.4213C26.6953 25.8894 24.2922 25.3827 23.2691 24.297C22.9458 23.9544 22.6273 23.7903 22.3378 23.7903C21.7105 23.7903 21.2279 24.5527 21.1217 25.8943Z"
        fill="url(#paint3_linear_19_1165)"
      />
      <path
        d="M37.0897 21.4837L36.834 25.4165C36.7037 27.3854 35.4973 29.5135 34.1461 30.1505C32.7949 30.7875 33.181 31.9263 35.005 32.6791L42.118 35.6227C43.9421 36.3804 44.801 35.5118 44.0289 33.6926L38.7256 21.2086C38.3588 20.3496 38.0066 19.925 37.717 19.925C37.3937 19.925 37.1573 20.451 37.0897 21.4837Z"
        fill="url(#paint4_linear_19_1165)"
      />
      <path
        d="M49.4626 13.3862L35.7 14.7181C33.7359 14.9063 33.6442 15.6205 35.4973 16.3058L39.3288 17.7197C41.1819 18.4049 42.8467 20.1711 43.0349 21.6525C43.2231 23.134 44.4247 23.1195 45.7083 21.6188L50.7076 15.7653C51.8899 14.3803 51.5039 13.3621 49.8969 13.3621C49.757 13.3669 49.6122 13.3718 49.4626 13.3862Z"
        fill="url(#paint5_linear_19_1165)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_19_1165"
        x1="17.9166"
        y1="0"
        x2="17.9166"
        y2="44.001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1D2088" />
        <stop offset="1" stop-color="#004EA2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_19_1165"
        x1="36.6709"
        y1="1.0904"
        x2="33.0483"
        y2="17.8206"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F39800" />
        <stop offset="1" stop-color="#FFD900" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_19_1165"
        x1="16.1703"
        y1="10.3857"
        x2="30.6843"
        y2="19.0034"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F39800" />
        <stop offset="1" stop-color="#FFD900" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_19_1165"
        x1="18.6527"
        y1="32.6733"
        x2="31.3398"
        y2="21.6047"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F39800" />
        <stop offset="1" stop-color="#FFD900" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_19_1165"
        x1="40.7285"
        y1="37.1238"
        x2="33.9892"
        y2="21.5072"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F39800" />
        <stop offset="1" stop-color="#FFD900" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_19_1165"
        x1="51.7226"
        y1="17.5232"
        x2="34.5626"
        y2="19.2778"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F39800" />
        <stop offset="1" stop-color="#FFD900" />
      </linearGradient>
    </defs>
  </svg>
);
